import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "@/api/DynamicBaseQuery";
import { APIEndpoints } from "@/constants/apiEndpoints";
import type { IApiResponse } from "@/types";
import type { IReferral, ISubmitReferralPayload } from "@/types/(company)/recruitment.interface";

export interface IReferableJob {
  id: number;
  title: string;
  department: string;
  location: string;
}

export const employeeReferralsApi = createApi({
  reducerPath: "employeeReferralsApi",
  baseQuery: dynamicBaseQuery,
  tagTypes: ["MyReferral"],
  endpoints: (builder) => ({
    msGetReferableJobs: builder.query<IApiResponse<IReferableJob[]>, void>({
      query: () => ({ url: APIEndpoints.EmployeeReferrals.Jobs }),
    }),

    msListMyReferrals: builder.query<IApiResponse<IReferral[]>, void>({
      query: () => ({ url: APIEndpoints.EmployeeReferrals.Base }),
      providesTags: [{ type: "MyReferral", id: "LIST" }],
    }),

    msSubmitReferral: builder.mutation<IApiResponse<IReferral>, ISubmitReferralPayload>({
      query: (body) => ({ url: APIEndpoints.EmployeeReferrals.Base, method: "POST", body }),
      invalidatesTags: [{ type: "MyReferral", id: "LIST" }],
    }),
  }),
});

export const { useMsGetReferableJobsQuery, useMsListMyReferralsQuery, useMsSubmitReferralMutation } =
  employeeReferralsApi;
